module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/related/id/6-8f8aac12292c80ca0d83efd65093a327.jpg";